// src/stores/useCompetitorStore.js
import { defineStore } from 'pinia';

export const useCompetitorStore = defineStore('competitor', {
  state: () => ({}),
  actions: {
    async addCompetitor({ competitor, weblink }) {
      try {
        const response = await fetch(
          'https://rwnbpxpxauytxfuuffsg.supabase.co/functions/v1/new-competitor',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ competitor, weblink }),
          }
        );
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || 'Failed to add competitor');
        }
        return await response.json();
      } catch (error) {
        console.error('Error adding competitor:', error);
        throw error;
      }
    },
  },
});
